import * as React from 'react';
export const OrderItemsSettingsContext = React.createContext(null);
export const OrderItemsSettingsContextProvider = OrderItemsSettingsContext.Provider;
